import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgForms = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "Layer_1",
	x: "0px",
	y: "0px",
	viewBox: "0 0 512 512",
	style: { enableBackground: "new 0 0 512 512" },
	xmlSpace: "preserve",
	width: "512px",
	height: "512px",
	className: "hovered-paths",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
		d: "M306.087,166.957c-9.217,0-16.696-7.479-16.696-16.696V0H72.348c-9.217,0-16.696,7.479-16.696,16.696v478.609    c0,9.217,7.479,16.696,16.696,16.696h367.304c9.217,0,16.696-7.479,16.696-16.696V166.957H306.087z M139.13,411.826    c-9.22,0-16.696-7.475-16.696-16.696s7.475-16.696,16.696-16.696s16.696,7.475,16.696,16.696S148.351,411.826,139.13,411.826z     M139.13,345.043c-9.22,0-16.696-7.475-16.696-16.696s7.475-16.696,16.696-16.696s16.696,7.475,16.696,16.696    S148.351,345.043,139.13,345.043z M139.13,278.261c-9.22,0-16.696-7.475-16.696-16.696c0-9.22,7.475-16.696,16.696-16.696    s16.696,7.475,16.696,16.696C155.826,270.786,148.351,278.261,139.13,278.261z M372.87,411.826H205.913    c-9.217,0-16.696-7.479-16.696-16.696s7.479-16.696,16.696-16.696H372.87c9.217,0,16.696,7.479,16.696,16.696    S382.087,411.826,372.87,411.826z M372.87,345.043H205.913c-9.217,0-16.696-7.479-16.696-16.696s7.479-16.696,16.696-16.696    H372.87c9.217,0,16.696,7.479,16.696,16.696S382.087,345.043,372.87,345.043z M372.87,278.261H205.913    c-9.217,0-16.696-7.479-16.696-16.696c0-9.217,7.479-16.696,16.696-16.696H372.87c9.217,0,16.696,7.479,16.696,16.696    C389.565,270.782,382.087,278.261,372.87,278.261z",
		className: "active-path",
		fill: "#1098B3"
	}) }) }), /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("polygon", {
		points: "322.783,9.783 322.783,133.565 446.565,133.565   ",
		className: "active-path",
		fill: "#1098B3"
	}) }) })] })
});
export default SvgForms;
